interface ICoordinates {
    latitude: number;
    longitude: number;
}

class SiteLabelCoordinates 
    extends SiteLabel<ICoordinates, ISiteLabelInputConfig> {

    private _input: IQueryElement;
    private _timer?: number;
    private _current: ICoordinates | null;
    private _mapComponent: SiteElementMap; // Hold reference to our map component.
    private _marker: any; // Will hold the currently active marker.
    private _isInitialized: boolean;

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);

        let input = this.query("input").first();
        let buttons = this.query(".buttons").first();
        let mapComponent = this.query(".results")
            .create<SiteElementMap, HTMLElement>(a => new SiteElementMap(card, a));

        if (input === null || mapComponent === null || buttons === null)
            throw 'SiteLabelCoordinates: Missing element(s)';

        this._input = input;
        this._mapComponent = mapComponent;
        this._current = null;
        this._isInitialized = false;

        // Listen for map initialization and add click handler on the map.
        this._mapComponent.on("qts.initialized", () => {
            const map = this._mapComponent.getMap();
            google.maps.event.addListener(map, "click", (e: any) => {
                const coords: ICoordinates = {
                    latitude: e.latLng.lat(),
                    longitude: e.latLng.lng(),
                };
                this.setValue(coords);
            });

            this._isInitialized = true;
            this.setValue(this.getValue());
        });


        // Add mylocation button
        let myLocation = new SiteButton({
            icon: 'my_location',
            title:  this.getSiteConfig().strings["current location"]
        }).appendTo(buttons);

        if ("geolocation" in navigator) {
            myLocation.on("click", (e) => {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const coords: ICoordinates = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        };
                        this.setValue(coords);
                    },
                    (error) => {
                        console.error("Error obtaining geolocation:", error);
                    }
                );
            });
        } else {
            myLocation.disable();
        }

        let clearButton = new SiteButton({
            icon: "clear",
            title: this.getSiteConfig().strings["clear"]
        }).appendTo(buttons);
        clearButton.on("click", (e) => {
            this.setValue(null);
        })
    }

    getInput() {
        return this._input;
    }

    
    async defaultKeyDownHandler(e: KeyboardEvent) {
        if (e.key === 'Enter') {
            const queryText = this._input.getVal();
            if (!queryText) {
                return;
            }

            const url = `/Routing/Api/GetCoordinates?text=${encodeURIComponent(queryText)}`;
            const req = new QueryRequest(url, { method: 'get', useCache: false });
            try {
                const response = await req.request();
                if (response.ok) {
                    const coords: ICoordinates = await response.json();
                    // Update the value (and marker on the map) using the returned coordinates.
                    this.setValue(coords);
                } else {
                    console.error("Request failed with status", response.status, response.statusText);
                }
            } catch (error) {
                console.error("Error occurred during request:", error);
            }

            return;
        }
        
        super.defaultKeyDownHandler(e);
    }

    defaultConfig(): ISiteLabelInputConfig {
        return {
            popout: "always",
            setValueTimeout: 0,
            scroll: "top"
        };
    }

    makeActive() {
        if (super.makeActive()) {
            this._input.select();
            return true;
        }
        return false;
    }

    getValue() {
        return this._current;
    }
    
    setValue(value: ICoordinates | null) {
        super.setValue(value);
        this._current = value;

        const map = this._mapComponent.getMap();

        // Remove old marker
        if (this._marker) {
            this._marker.setMap(null);
            this._marker = null;
        }

        // Add new marker
        if (this._isInitialized && value) {
            const position = new google.maps.LatLng(value.latitude, value.longitude);
            this._marker = new google.maps.Marker({
                position,
                map
            });

            // Zoom to new location
            map.panTo(position);
            map.setZoom(16);
        }
    }
}